import { useContext } from "react";

import ValueContext from "../providers/ValueProvider";

const useValues = () => {
    return useContext(ValueContext);
};

export default useValues;